import { createCookie, eraseCookie, readCookie } from '@paragon/client-tools';

import { ThunkActionReturn, ThunkActionVoid } from './thunkActions';

function getJwtCookieLabel(): ThunkActionReturn<string> {
  return (dispatch, getState) => {
    const environment = getState().environment.activeEnvironment;

    return `${environment}JwtToken`;
  };
}

export function cookiesStoreToken(token: string): ThunkActionVoid {
  return (dispatch) => {
    const jwtCookieLabel = dispatch(getJwtCookieLabel());
    createCookie(jwtCookieLabel, token, { days: 365 });
  };
}

export function cookiesFetchToken(): ThunkActionReturn<string | null> {
  return (dispatch) => {
    const jwtCookieLabel = dispatch(getJwtCookieLabel());
    return readCookie(jwtCookieLabel);
  };
}

export function cookiesRemoveToken(options: { reload?: boolean } = {}): ThunkActionVoid {
  return (dispatch) => {
    const jwtCookieLabel = dispatch(getJwtCookieLabel());
    eraseCookie(jwtCookieLabel);

    if (options?.reload) {
      window.location.reload();
    }
  };
}
